import { useState } from 'react';
import { StyleSheet, View } from 'react-native';
import type { LayoutChangeEvent } from 'react-native';

import NotificationPermissionSvg from '@/../assets/illustrations/notification-permission-prompt.svg';
import NotificationPermissionJaSvg from '@/../assets/illustrations/notification-permission-prompt.ja.svg';
import { useTranslation } from '@/i18n';

const REFERENCE_WIDTH = 412;
const REFERENCE_HEIGHT = 407;

export const NotificationPermissionIllustration = () => {
  const { locale } = useTranslation();
  const [width, setWidth] = useState(0);
  const Svg = locale === 'ja' ? NotificationPermissionJaSvg : NotificationPermissionSvg;

  const handleLayout = (event: LayoutChangeEvent) => {
    setWidth(event.nativeEvent.layout.width);
  };

  return (
    <View
      style={styles.container}
      testID="notification-permission-illustration-container"
      onLayout={handleLayout}>
      {width > 0 ? (
        <Svg
          height={(width * REFERENCE_HEIGHT) / REFERENCE_WIDTH}
          testID="notification-permission-illustration"
          width={width}
        />
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    aspectRatio: REFERENCE_WIDTH / REFERENCE_HEIGHT,
  },
});
